import axios from "axios";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

// components

export default function CardUserTable() {
  const [datas, setDatas] = useState("");
  const [pending, setPending] = useState(true);
  useEffect(() => {
    axios.get(`http://${process.env.REACT_APP_API_URL}/users/search-all`, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      // console.log(response);
      if (response.status === 200) {
        setDatas(response.data);
        setPending(false);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
      // console.log(error.response.data.message);
    });
  }, [])
  // console.log(datas);
  const columns = [
    {
      name: 'username',
      selector: row => row.username,
      sortable: true,
    },
    {
      name: 'name',
      selector: row => row.nameTh + " " + row.lastnameTh,
    },
    {
      name: 'tel',
      selector: row => row.tel,
    },
    {
      name: 'role',
      selector: row => row.role == 99 ? "Super Admin" :row.role == 1 ? "Admin" : "Sales",
    },
    {
      name: 'team',
      selector: row => row.team,
    },
    {
      name: 'Edit',
      button: true,
      cell: (row) => <button onClick={() => window.location.href = "/admin/update-user/" + row.username}><i className="mr-2 text-sm fas fa-pen" /></button>,
    },
    {
      name: 'Delete',
      button: true,
      cell: (row) => <button onClick={() => handleDelete(row)}><i className="mr-2 text-sm fas fa-trash" /></button>,

    },

  ];

  const handleDelete = (row) => {
    const user = { isDelete: 1, username: row.username }
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(`http://${process.env.REACT_APP_API_URL}/users/save`, user, {
          headers: {
            Bearer: localStorage.getItem('token')
          }
        }).then((response) => {
          // console.log(response);
          if (response.status === 200) {
            Swal.fire({
              title: "Deleted!",
              text: "Your file has been deleted.",
              icon: "success"
            });
            window.location.href = "/admin/user";
          }
        }
        ).catch((error) => {
          if (error.response.data.status === 401) {
            window.location.href = "/auth/login";
          }
          console.log(error);
          // console.log(error.response.data.message);
        });
      }
    });
  }

  const customStyles = {
    table: {
      style: {
        borderRadius: "20px",
      },
    },
    rows: {
      style: {
        minHeight: '72px',
        // override the row height
        '&:hover': {
          // cursor: 'pointer',
          backgroundColor: "#B4BDFF",

        },
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
        backgroundColor: "#83A2FF",

      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',

      },

    },

  };
  return (
    <>

      <div className="block w-full mb-1 overflow-x-auto rounded-lg ">
        <DataTable
          data={datas}
          columns={columns}
          pagination
          customStyles={customStyles}
          progressPending={pending}
        />
      </div>
    </>
  );
}
